export default __webpack_public_path__ + "e5e2061d8aae970227eb4951ebfa8df7.png";